<template>
  <router-view />
</template>

<script>
export default {
  name: "LaboratorySingle"
};
</script>